import React from "react";
import { Modal } from "react-bootstrap";
import logoImage from "../../images/people-whatzon.svg";
import blackLogo from "../../images/whatzon-black.svg";
import { UPDATE_TERMS_AND_CONDITION_FLAG } from "../../mutation/updateTermsAndConditionFlag";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";

const TermsAndConditionPopup = (props) => {
  const [updateTermsAndConditionFlag] = useMutation(
    UPDATE_TERMS_AND_CONDITION_FLAG,
    {
      client: hasuraClient,
    }
  );
  const userRole = localStorage.getItem("user_profile_role") || "";
  const history = useHistory();
  return (
    <Modal
      {...props}
      className="tAndC-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="left-side-t-and-c">
          <div className="wlcm-class mb-3">WELCOME TO WHATZON</div>
          <div className="desc-heading mb-3">
            Congratulations on choosing to list your{" "}
            {userRole.toLowerCase().includes("business") ? "business" : ""}
            {userRole.toLowerCase().includes("club")
              ? "Registered Club"
              : ""}{" "}
            on the Whatzon App.
          </div>
          {userRole.toLowerCase().includes("business") ? (
            <div className="desc-text mb-3">
              We are an all-Australian owned company that has three founders
              based in country Victoria. With a background in both business and
              the Registered Club industry, we have built this application
              specifically for business owners right across Australia.
            </div>
          ) : userRole.toLowerCase().includes("club") ? (
            <div className="desc-text mb-3">
              We are an all-Australian owned company that has three founders
              based in country Victoria. With a background in the club industry,
              we have built this application for Registered clubs right across
              Australia.
            </div>
          ) : null}
          {userRole.toLowerCase().includes("club") ? (
            <>
              <div className="desc-text mb-3">
                You have a large audience to market to, so please make the most
                of your listing.
              </div>
              <div className="desc-text mb-3">
                <span className="desc-heading">
                  There is a small Annual subscription fee{" "}
                </span>{" "}
                of: 15 cents plus GST per member per year. (eg. If you have
                10,000 members then the annual cost would be $1,650 inc gst)
              </div>
              <div className="desc-text mb-3">
                Click <span className="desc-heading">“I Acknowledge”</span>{" "}
                below to submit your member details and we will forward an
                invoice within the next 14 days.
              </div>
              <div className="desc-heading mb-3">Why do we charge clubs?</div>
              <div className="desc-text mb-3">
                The 15 cents per member simply covers our cloud storage costs,
                amongst other software fees that our company pays to the IT
                providers monthly.
              </div>
              <div className="desc-text mb-3">
                The fee does not provide us a profit, it simply covers the cost
                of keeping the application running.
              </div>
              <div className="desc-text mb-3">
                The application will be available to all Registered Clubs across
                Australia as well as other businesses.
              </div>
              <div className="desc-heading mb-3">
                Clubs listed Deals will be available to all users of the
                application even if they have not paid an annual subscription to
                access deals.
              </div>
              <div className="desc-text mb-3">
                Unlike all other businesses listed on the app,{" "}
                <span className="desc-heading">Registered Club Deals</span> will
                be available to all users of the app.{" "}
                <span className="desc-heading">
                  Deals posted by Businesses will only be accessible once a user
                  has paid the monthly or annual subscription.
                </span>
              </div>
              <div className="desc-text mb-3">
                One application for all clubs, to drive business through your
                door. Regardless where your costomers are from, when they come
                into your area, your club will be at their finger-tips.
              </div>
            </>
          ) : null}
          {userRole.toLowerCase().includes("business") && (
            <>
              <div className="desc-text mb-3">
                Registered Clubs will be encouraging their members to download
                the application to keep up to date with Events and Deals in
                their area. With over 13 million Club Members across Australia:
                you have a large audience to market to, so please make the most
                of your free listing.
              </div>
              <div className="desc-text mb-3">
                The application is funded through a small annual subscription
                paid for <span className="desc-heading">by users</span> of the
                app,{" "}
                <span className="desc-heading text-decoration-underline">
                  not you
                </span>{" "}
                <span className="desc-heading">the Business owners.</span>
              </div>
              <div className="desc-text mb-3">
                So Yes it is completely free for businesses to use.
              </div>
              <div className="desc-text">
                The only conditions of use are as follows:
              </div>
              <ul className="desc-text mb-3">
                <li>
                  We ask that you load at least one new genuine deal every 30
                  days.
                </li>
                <li>
                  We ask that you only honour the deal to those that present
                  their QR code in store. (QR Code example at the end of this
                  document )
                </li>
              </ul>
            </>
          )}

          <div className="desc-text mb-3">
            That’s It. It’s great to have you on onboard. Instructional videos
            are available on our website{" "}
            <a
              href="https://www.whatzon.com.au"
              target="_blank"
              rel="noreferrer"
            >
              www.whatzon.com.au
            </a>{" "}
            should you need to know more.
          </div>
          <div className="desc-text mb-3">
            Should you have any questions please do not hesitate to contact us
            on the following email address:{" "}
            <a href="mailto:steve@whatzon.net.au" rel="noreferrer">
              steve@whatzon.net.au
            </a>
            .
          </div>
          <div className="desc-text mb-3">
            Please also put forward any suggestions on how we may improve.
          </div>
          <div className="desc-text">Regards</div>
          <div className="desc-text">The Team at Whatzon</div>
          <div className="button-row">
            <div
              onClick={() => {
                updateTermsAndConditionFlag({
                  variables: {
                    user_id: localStorage.getItem("user_id") || "",
                    term_and_conditions: true,
                  },
                })
                  .then(async (response) => {
                    if (
                      response?.data?.update_users?.returning[0]
                        .term_and_conditions
                    ) {
                      if (userRole.toLowerCase().includes("club")) {
                        props.setIsMemberShipModalOpen(true);
                        props.setIsTandCModalOpen(false);
                      } else {
                        localStorage.removeItem("user_profile_role");
                        localStorage.removeItem("term_and_conditions");
                        props.setIsTandCModalOpen(false);
                        props.setNewModalOpen(true);
                        localStorage.setItem("isnewuser", true);
                      }
                    } else {
                      history.push("/dashboard");
                    }
                  })
                  .catch((e) => {
                    const errors = e.graphQLErrors;
                    console.log("errors", errors);
                    props.setIsTandCModalOpen(false);
                    history.push("/login");
                  });
              }}
              className="button"
              style={{ cursor: "pointer" }}
            >
              I Acknowledge
            </div>
          </div>
        </div>
        <div className="bg-div-right-container">
          <div className="bg-image-right">
            <div className="bg-internal-container">
              <img className="" src={logoImage} alt="logoImage" />
              <img className="" src={blackLogo} alt="blackLogo" />
              <p className="bg-text-dec">
                Connect to new customers & grow your business
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TermsAndConditionPopup;
